import axios from "axios";
import NProgress from "nprogress";

import { logout, getAuthorizationToken, redirectTo } from "./auth";
import VueCookies from "vue-cookies";

const newUrl = JSON.parse(localStorage.getItem("baseUrl"));

export const HMD_BACKEND_API_URL =
  process.env.VUE_APP_ROOT_API || "http://localhost:8002/api";

export const HTTP = axios.create({
  baseURL: HMD_BACKEND_API_URL,
  timeout: 180000
});

HTTP.interceptors.request.use(
  config => {
    NProgress.start();

    if (newUrl) {
      config.baseURL = newUrl.domain + "/api";
    }

    if (localStorage.getItem("token") != null) {
      config.headers.authorization = "Token " + localStorage.getItem("token");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  config => config,
  response => {
    // intercept the global error
    NProgress.done();
    return response;
  },
  error => {
    NProgress.done();
    const res = error.response;

    if (!res) {
      if (!error.__CANCEL__) {
        return new Promise((resolve, reject) => {
          // logout(null);
          return reject(error);
        });
      }
    } else if (
      res.status === 401 &&
      res.config &&
      !res.config.__isRetryRequest
    ) {
      return new Promise((resolve, reject) => {
        // logout(null);
      });
    } else if (res.status === 404 || res.status === 403) {
      console.log("ERROR");
      // return redirectTo(res.status)
    }
    return Promise.reject(error);
  }
);
